module.exports = __webpack_public_path__ + "img/2.ca4f4fde.png";